import { hiddenUserData } from "helpers/hiddenData";
import { formatNumber } from "helpers/system";
import Tooltip from "rc-tooltip";
import React from "react";

const CostBreakdown = ({ costs, currency, hidden, price, priceLabel, priceWithoutCosts }) => {
    const formatPrice = (value) =>
        value == null
            ? "—"
            : hiddenUserData(formatNumber(value, { style: "currency", currency }), { type: "price" }, hidden);
    const details = [
        { label: priceLabel, value: price },
        { label: "Платные дороги", value: costs?.tollRoadsCost },
        { label: "Платон", value: costs?.platonCost },
        { label: "Прочие расходы", value: costs?.expensesCost },
        { label: "Цена с учётом затрат", value: priceWithoutCosts },
    ];

    return (
        <dl className="row mb-0">
            {details.map((detail) => (
                <React.Fragment key={detail.label}>
                    <dt className="col-sm-7 mb-2">{detail.label}</dt>
                    <dd className="col-sm-5 mb-2 text-sm-right">{formatPrice(detail.value)}</dd>
                </React.Fragment>
            ))}
        </dl>
    );
};

const CostAwarePrice = ({ costs, currency, hidden, modal, price, priceLabel, priceWithoutCosts }) => {
    if (priceWithoutCosts == null) {
        return null;
    }

    const showBreakdown = () => {
        modal({
            name: "default",
            title: "Расшифровка цены с учётом затрат",
            CustomBody: CostBreakdown,
            bodyData: { costs, currency, hidden, price, priceLabel, priceWithoutCosts },
        });
    };

    return (
        <>
            <div className="show-bid__main-info--title">Цена с учётом затрат</div>
            <div className="show-bid__main-info--value" data-test-id="price-without-costs">
                {hiddenUserData(
                    formatNumber(priceWithoutCosts, { style: "currency", currency }),
                    { type: "price" },
                    hidden,
                )}
                {costs && (
                    <Tooltip overlay="Показать расшифровку затрат">
                        <button
                            type="button"
                            className="btn btn-link border-0 p-0 pl-2 cursor-pointer"
                            onClick={showBreakdown}
                            aria-label="Показать расшифровку затрат"
                        >
                            <i className="icon-uEA69-question-circle" aria-hidden="true" />
                        </button>
                    </Tooltip>
                )}
            </div>
        </>
    );
};

export default CostAwarePrice;
